import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useGetPathPickCounts from "@/features/pathpick/hooks/query/useGetPathPickCounts";

// GNB 담은 상품 메뉴의 개수 배지 — 담기/삭제 invalidation으로 자동 갱신된다.
// 비suspense useQuery라 로딩/에러 시에는 data가 없어 배지가 조용히 숨겨진다.
function PathPickBasketNavCountBadge() {
  // 개수 전용 API — 상품 목록으로 개수만 얻으면 두 소스 조회·크림 조인까지 다 돌아 느리다.
  const { pathPickCounts } = useGetPathPickCounts();

  const totalCount = pathPickCounts?.basket.totalCount ?? 0;

  // 0개면 배지를 표시하지 않는다.
  if (totalCount === 0) {
    return null;
  }

  return (
    <Flex
      minWidth={"20px"}
      height={"20px"}
      padding={"0 6px"}
      borderRadius={"full"}
      background={"#D3E5FA"}
      alignItems={"center"}
      justifyContent={"center"}
      flexShrink={0}
    >
      <Text textStyle={"caption-bold"} color={"#1272EF"}>
        {totalCount}
      </Text>
    </Flex>
  );
}

export default PathPickBasketNavCountBadge;
